<div class="section">
  <div class="section-header">
    <h2>
      {{ 'pages.serviceProcessing.processHistory.baseInfoTitle' | translate }}
    </h2>
    <app-tooltip [marginBottom]="false" text="serviceProcessHistoryTitleBackoffice" />
  </div>
  <div class="section-content">
    <div class="lna-row full-width">
      <div class="value-wrapper">
        <p class="form-label lna">
          {{ 'pages.serviceProcessing.processHistory.submissionDate' | translate }}
        </p>
        <p class="form-value">
          {{ this.formatDate(application?.submittedOn) }}
        </p>
      </div>
      <div class="value-wrapper">
        <p class="form-label lna">
          {{ 'pages.serviceProcessing.processHistory.code' | translate }}
        </p>
        <p class="form-value">
          {{ application?.code }}
        </p>
      </div>
    </div>
    <div class="lna-row full-width">
      @if (application?.createdByType === 'User') {
        <div class="value-wrapper">
          <p class="form-label lna">
            {{ 'pages.serviceProcessing.processHistory.submittedByLnaWorker' | translate }}
          </p>
          <p class="form-value">
            {{ application?.createdByType === 'User' ? application?.createdBy : '-' }}
          </p>
        </div>
      }

      <div class="value-wrapper">
        <p class="form-label lna">
          {{ 'pages.serviceProcessing.processHistory.responsibleStructuralUnit' | translate }}
        </p>
        <p class="form-value">
          {{ application?.readingRoom?.structuralUnitName }}
        </p>
      </div>
      <div class="value-wrapper">
        <p class="form-label lna">
          {{ 'pages.serviceProcessing.processHistory.responsibleUser' | translate }}
        </p>
        <p class="form-value">
          {{ application?.responsibleUser?.fullName ?? '-' }}
        </p>
      </div>
    </div>
    @if (this.application?.resultNote) {
      <div class="lna-row full-width mb-0">
        <div class="value-wrapper">
          <p class="form-label lna">
            {{ 'pages.service.visitRoom.summary.approvalNoteLabel' | translate }}
          </p>
          <p class="form-value">
            {{ this.application?.resultNote }}
          </p>
        </div>
      </div>
    }
  </div>
</div>
<div class="section p-0">
  <app-card-table [config]="tableConfig" />
</div>
